export const province = [
    {
        provinceNum:"050000",
        provinceName:"河北省"
    },
    {
        provinceNum:"030000",
        provinceName:"山西省"
    },
    {
        provinceNum:"110000",
        provinceName:"辽宁省"
    },
    {
        provinceNum:"130000",
        provinceName:"吉林省"
    },
    {
        provinceNum:"150000",
        provinceName:"黑龙江省"
    },
    {
        provinceNum:"210000",
        provinceName:"江苏省"
    },
    {
        provinceNum:"310000",
        provinceName:"浙江省"
    },
    {
        provinceNum:"230000",
        provinceName:"安徽省"
    },
    {
        provinceNum:"350000",
        provinceName:"福建省"
    },
    {
        provinceNum:"330000",
        provinceName:"江西省"
    },
    {
        provinceNum:"250000",
        provinceName:"山东省"
    },
    {
        provinceNum:"450000",
        provinceName:"河南省"
    },
    {
        provinceNum:"430000",
        provinceName:"湖北省"
    },
    {
        provinceNum:"410000",
        provinceName:"湖南省"
    },
    {
        provinceNum:"510000",
        provinceName:"广东省"
    },
    {
        provinceNum:"570200",
        provinceName:"海南省"
    },
    {
        provinceNum:"610000",
        provinceName:"四川省"
    },
    {
        provinceNum:"550000",
        provinceName:"贵州省"
    },
    {
        provinceNum:"650000",
        provinceName:"云南省"
    },
    {
        provinceNum:"710000",
        provinceName:"陕西省"
    },
    {
        provinceNum:"730000",
        provinceName:"甘肃省"
    },
    {
        provinceNum:"810000",
        provinceName:"青海省"
    },
    {
        provinceNum:"010000",
        provinceName:"内蒙古自治区"
    },
    {
        provinceNum:"530000",
        provinceName:"广西壮族自治区"
    },
    {
        provinceNum:"850000",
        provinceName:"西藏自治区"
    },
    {
        provinceNum:"750000",
        provinceName:"宁夏回族自治区"
    },
    {
        provinceNum:"830000",
        provinceName:"新疆维吾尔自治区"
    },
    {
        provinceNum:"100000",
        provinceName:"北京市"
    },
    {
        provinceNum:"300000",
        provinceName:"天津市"
    },
    {
        provinceNum:"200000",
        provinceName:"上海市"
    },
    {
        provinceNum:"400000",
        provinceName:"重庆市"
    }
]
